import React from 'react';

import classNames from 'classnames';

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  wrapperClassName?: string;
  className?: string;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ checked = false, onChange, wrapperClassName, className }) => {
  const handleToggle = () => {
    onChange(!checked);
  };

  return (
    <button
      type="button"
      onClick={handleToggle}
      className={classNames(
        'v2-relative v2-inline-flex v2-items-center v2-rounded-full v2-transition-colors v2-duration-300 v2-ease-in-out focus:v2-outline-none',
        'v2-h-[20px] v2-w-[36px]',
        checked ? 'v2-bg-[#154734]' : 'v2-bg-gray-300',
        wrapperClassName
      )}
    >
      <span
        className={classNames(
          'v2-absolute v2-top-[1.7px] v2-rounded-full v2-bg-white v2-transition-transform v2-duration-300 v2-ease-in-out',
          'v2-h-[16px] v2-w-[16px]',
          checked ? 'v2-translate-x-[18px]' : 'v2-translate-x-[2px]',
          className
        )}
      />
    </button>
  );
};

export default ToggleSwitch;
